import React from 'react';
import cui from 'components/cui/cui';

const I18nService = (id, { intl, href, onClick, color, ...rest }) => {

  const parentObj = {...rest};
  const styleText = {
    cursor: 'pointer',
    textDecoration: 'underline',
    color: color || '#1C60B3'
  }

  if (href) {
    parentObj.a = str => <a href={href}>{str}</a>
  }

  if (cui.isFunction(onClick)) {
    parentObj.span = str => <span style={styleText} onClick={onClick}>{str}</span>
  }

  return intl.formatMessage({
    id,
    defaultMessage: intl.formatMessage({ id })
  }, parentObj)
}

export default I18nService;
